export default __webpack_public_path__ + "apply103bc4e9.png";